import { useI18n, LANGS } from "../lib/i18n";

export default function LangSwitcher() {
  const { lang, setLang } = useI18n();
  return (
    <div className="flex items-center gap-1 font-mono text-xs" data-testid="lang-switcher">
      {LANGS.map((l) => (
        <button
          key={l.code}
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          className={`px-2 py-1 rounded transition-colors duration-200 ${
            lang === l.code ? "text-nhgreen text-glow-green" : "text-white/40 hover:text-white"
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
